"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var headless_exports = {};
__export(headless_exports, {
  Root: () => import_Root.Root,
  createApp: () => createApp
});
module.exports = __toCommonJS(headless_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_setup = require("./setup");
var import_Root = require("./Root");
var import_clientLoaderResolver = require("./clientLoaderResolver");
var import_render = require("./render");
var import_dynamicImport = require("./utils/dynamicImport");
var import_findRootLayout = require("./utils/findRootLayout");
function createApp(options) {
  globalThis["__vxrnIsSPA"] = true;
  globalThis["__vxrnHeadless"] = true;
  var setupComplete = options.getSetupPromise ? options.getSetupPromise() : Promise.resolve();
  return setupComplete.then(function() {
    return (0, import_findRootLayout.findRootLayout)(options.routes, options.routerRoot);
  }).then(function() {
    return (0, import_clientLoaderResolver.resolveClientLoader)({});
  }).then(function() {
    (0, import_render.render)(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Root.Root, {
      isClient: true,
      flags: options.flags,
      routes: options.routes,
      routerRoot: options.routerRoot,
      linking: options.linking,
      path: options.path || (typeof window !== "undefined" ? window.location.href : "/")
    }));
  }).catch(function(err) {
    console.error(`[one/headless] Error during initialization:`, err);
    if ((0, import_dynamicImport.isChunkLoadError)(err)) {
      (0, import_dynamicImport.handleSkewError)();
    }
  });
}
//# sourceMappingURL=headless.js.map
